/* eslint-disable react/prop-types */
import React from 'react'

const SelectedItemWithForm: React.FC<SelectedItemWithForm> = props => {
    const { onClose, event, Form, ...rest } = props

    return (
        <div
            aria-labelledby="plugin-annotations_export-extension-point"
            className="dropdown-menu dropdown-menu-right"
            role="menu"
        >
            <Form event={event} onClose={onClose} {...rest} />
        </div>
    )
}

export default SelectedItemWithForm
